// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jque","col":"styles_col__scpKH"};